import { safeGet } from "../utils/request-helpers";
import { route } from "ziggy-js";
export const getBrandBalance = (brandID) => {
    return safeGet(route('api.v1.brand.qb.balance', { brandID }));
};
export const getBrandOptions = () => {
    return safeGet(route('api.v1.brand.list'));
};
